<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Seamlessly integrate with your existing development workflow'
    "
    [icon]="'@tui.workflow'"
    [subtitle]="'Integrations'"
    [title]="'Works with your tools'"
  >
  </app-section-header>
  <div class="flex w-full flex-col gap-8">
    <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4">
      @for (integration of integrations; track integration.name) {
        <div
          class="flex flex-col gap-2 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
        >
          <div class="flex flex-row items-center gap-2">
            <tui-icon [icon]="integration.icon" />
            <h3 class="text-lg font-bold">{{ integration.name }}</h3>
          </div>
          <p class="text-base text-gray-500">
            {{ integration.description }}
          </p>
        </div>
      }
    </div>
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 text-center md:p-6"
    >
      <div class="flex items-center justify-center gap-2">
        <tui-icon icon="@tui.terminal" />
        <h3 class="text-xl font-bold">CLI Tool</h3>
      </div>
      <p class="text-pretty text-lg">
        Use our powerful CLI tool to trigger and manage builds from your
        terminal or CI/CD pipeline.
      </p>
    </div>
  </div>
</section>
